// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-spacing[data-v-197bcb6e] {\n  margin-top: 72px;\n}\n.box-icon[data-v-197bcb6e] {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  height: 100px;\n}\n.box-icon__active[data-v-197bcb6e] {\n  background: grey;\n}\n.box-icon[data-v-197bcb6e]:hover {\n  background: grey;\n}", ""]);
// Exports
module.exports = exports;
